import { 
  Req_GetMsgReadInfo,
  Req_GetUnreadCount,
  Req_GetMissionMsg
} from '@/request/user'
import { Notification } from 'element-ui';
import Vue from 'vue'


export default {
  state: {
    showMessageBox: false,
    messageInfo: [],
    unreadCount: 0,
    messageTimer: null,
    controlNotify: false,
    notifyShow: null,
    missionBoxStatus: false,
    missionTaskId: '',
    missionMsgId: '',
    missionTimer: null
  },
  mutations: {
    updateMessageInfo(state,payload) {
      if(payload.length) {
        state.messageInfo = payload
        state.showMessageBox = true
      }
    },
    initShowMessageStatus(state,payload) {
      state.showMessageBox = false
    },
    updateUnreadCount(state,payload) {
      state.unreadCount = payload.unreadCount
    },
    closeNotify(state,payload) {
      if(state.notifyShow) state.notifyShow.close()
    },
    setMessageTimer(state) {
      state.messageTimer = setInterval(() => {
          if(state.controlNotify) return
          Req_GetMsgReadInfo({
            msgType: 20
          }).then(res => {
            if(res.length) {
              Req_GetUnreadCount({
                msgType: ''
              }).then(res => {
                state.unreadCount = res.unreadCount
              }).catch(err => this.$catchErr(err))

              state.controlNotify = true
              state.notifyShow = Notification({
                title: `${res[0].msgTitle} - ${res.length}条`,
                dangerouslyUseHTMLString: true,
                message: '<span style="color: #c0182f;font-size: 13px;cursor: pointer;">点击查看详情</span>',
                duration: 0,
                position: 'bottom-right',
                customClass: 'w-250 message-notification',
                onClick: () => {
                  Req_GetMsgReadInfo({
                    msgType: 20
                  }).then(result => {
                    state.notifyShow.close()
                    state.controlNotify = false
                    state.messageInfo = result
                    state.showMessageBox = true
                    clearInterval(state.messageTimer)
                    state.messageTimer = null
                  }).catch(err => Vue.prototype.$catchErr(err))
                },
                onClose: () => {
                  state.messageInfo = []
                  state.showMessageBox = false
                  state.controlNotify = false
                }
              })
            }
          }).catch(err => Vue.prototype.$catchErr(err))
      },3 * 60 * 1000)
    },
    clearMessageTimer(state) {
      clearInterval(state.messageTimer)
      state.messageTimer = null
    },
    setMissionPublish(state) {
      state.missionTimer = setInterval(() => {
          Req_GetMissionMsg().then(res => {
            res.forEach((item,index) => {
              const obj = JSON.parse(item.otherJson)
              setTimeout(() => {
                Notification({
                  // message: '你有一条新的自动化任务信息，请查收',
                  // title: item.msgTitle,
                  message: `<span>${item.msgContent}</span><span style="color:#f13736;font-size:13px;cursor: pointer;">(查看详情)</span>`,
                  dangerouslyUseHTMLString:true,
                  duration: 0,
                  position: 'bottom-right',
                  customClass: 'mission-box-zindex',
                  onClick: () => {
                    state.missionBoxStatus = true
                    state.missionTaskId = obj.taskId
                    state.missionMsgId = item.msgId
                  }
                })
              }, 1500 * index)
            })
          }).catch(err => Vue.prototype.$catchErr(err))
        },60000)
    },
    initMissionBox(state,payload) {
      state.missionBoxStatus = false
    },
    clearMissionTimer(state) {
      clearInterval(state.missionTimer)
      state.missionTimer = null
    },
  },
  actions: {
    setUnreadCount(store) {
      Req_GetUnreadCount({
        msgType: ''
      }).then(res => {
        store.commit('updateUnreadCount',res)
      }).catch(err => this.$catchErr(err))
    },
    setImportantMessage(store) {
      Req_GetMsgReadInfo({
        msgType: 10
      }).then(res => {
        if(res.length) store.commit('updateMessageInfo',res)
      }).catch(err => this.$catchErr(err))
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/message.js